<template>
    <div class="edit-answer">
        <div class="answer-content scroll-tracker">
            <TitleBar class="answer-title">
                <span class="" v-show="!isTilteEditing">{{ answerName }}</span>
                <span v-if="isTilteEditing"
                    ><input :placeholder="answerName" v-model="titleValue" @keypress="keyPressHandler" @blur="emitEditEvent" ref="titleInput"
                /></span>
                <a class="title-edit-btn" @click="editTitle" v-show="!isTilteEditing"></a>
                <div class="answer-action">
                    <RoundButton class="copy-btn" text="复制" @btnClick="copyClick" />
                    <RoundButton class="paste-btn" style="width:90px" text="覆盖粘贴" @btnClick="coverpasteClick('cover')" />
                    <RoundButton class="paste-btn" style="width:90px" text="叠加粘贴" @btnClick="coverpasteClick('coverlay')" />
                </div>
            </TitleBar>
            <div class="content-list">
                <WidgetWrapper v-for="widget in currentAnswer.contents" :key="widget.uid" :widget="widget" v-show="widget.updateState != 'delete'" />
            </div>
            <AnswerMore :isEmpty="!currentAnswer.contents.length" />
            <OptionsEdit />
        </div>
        <AnswerProp />
    </div>
</template>

<script>
import RoundButton from "../../../bComponents/buttons/RoundButton.vue";
import { ANSWER_COPY } from "../../../js/common/constants";
import { localStorage } from "../../../js/common/util";
import TitleBar from "../TitleBar";
import AnswerProp from "./AnswerProp";
import WidgetWrapper from "./WidgetWrapper";
import AnswerMore from "./AnswerMore";
import OptionsEdit from "./OptionsEdit";
import { uniqueId } from "../../../js/common/util.js";

export default {
    name: "AnswerPanel",
    components: {
        TitleBar,
        AnswerProp,
        WidgetWrapper,
        AnswerMore,
        OptionsEdit,
        RoundButton
    },
    data() {
        return {
            titleValue: "",
            isTilteEditing: false
        };
    },
    computed: {
        currentAnswer() {
            return this.getStorePorp("currentAnswer");
        },
        answerName() {
            return this.getStorePorp("currentAnswer").name;
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionEdit[propName];
        },
        emitEditEvent() {
            const newTitle = this.zhiji.strTrim(this.titleValue);
            const isChanged = newTitle != this.answerName;

            if (newTitle && isChanged) {
                this.titleValue = "";
                this.$store.commit("zhiji/editQsUpdateAnswer", {
                    type: "name",
                    newName: newTitle
                });
            }

            this.isTilteEditing = false;
        },
        keyPressHandler(event) {
            const isEnterKey = event.keyCode === 13;

            isEnterKey && this.emitEditEvent();
        },
        editTitle() {
            this.isTilteEditing = true;
            this.$nextTick(() => {
                this.$refs.titleInput && this.$refs.titleInput.focus();
            });
        },
        copyClick() {
            // 将当前答案内容保存到本地
            localStorage.set(ANSWER_COPY, {
                contents: this.currentAnswer.contents,
                options: this.currentAnswer.options
            });
            localStorage.get(ANSWER_COPY) &&
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: "复制成功！"
                    }
                });
        },
        coverpasteClick(pasteName) {
            // 获取复制的答案内容
            const answerDate = JSON.parse(localStorage.get(ANSWER_COPY));
            if (answerDate && (answerDate.contents.length > 0 || answerDate.options.length > 0)) {
                answerDate.contents.forEach(item => {
                    item.uId = uniqueId();
                });
                if (pasteName === "coverlay") {
                    // 叠加更新当前答案数据
                    this.$store.commit("zhiji/editQsUpdateAnswer", {
                        type: "updateCurrentAnswer",
                        contents: [...this.currentAnswer.contents, ...answerDate.contents],
                        options: [...this.currentAnswer.options, ...answerDate.options]
                    });
                } else {
                    // 覆盖更新当前答案数据
                    this.$store.commit("zhiji/editQsUpdateAnswer", {
                        type: "updateCurrentAnswer",
                        contents: answerDate.contents,
                        options: answerDate.options
                    });
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.edit-answer {
    display: flex;
    flex-direction: row;
    height: 100%;
    overflow-x: auto;
    background: #fff;

    .answer-content {
        padding: 0px 16px 0px 16px;
        flex: 1;
        overflow: auto;
        border-right: solid 1px #d8e4f0;

        .answer-title {
            margin: 0;
        }
    }

    .title-edit-btn {
        display: inline-block;
        width: 18px;
        height: 18px;
        margin: 0 5px 0 5px;
        vertical-align: -3px;
        background: url($zhijiStaticImagePath+"class-spr.png") -76px 0;

        &:hover {
            background-position: -76px -22px;
        }
    }
    .answer-action {
        margin-left: 5px;
        display: inline-block;

        .copy-btn,
        .paste-btn {
            width: 65px;
            height: 30px;
            min-width: 40px;
            border: solid 1px #d8e4f0;
            border-radius: 30px;
            color: #41475e;
            background: #fff;
            box-shadow: none;
            box-sizing: border-box;
            line-height: 28px;
            margin-right: 8px;
            &:hover {
                color: #2ec2ff;
            }
        }
    }
    .content-list {
        margin-left: 11px;
        padding: 1px;
        position: relative;
    }
}
</style>
